var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48711 15.8117C5.03855 14.5712 4.03908 13.0641 3.57623 12C4.03908 10.9359 5.03855 9.4288 6.48711 8.18833C7.95342 6.93267 9.81859 6 12.0007 6C14.1621 6 15.9758 6.91507 17.4154 8.1544C18.8417 9.38235 19.8545 10.8923 20.3997 12C19.8545 13.1077 18.8417 14.6176 17.4154 15.8456C15.9758 17.0849 14.1621 18 12.0007 18C9.81859 18 7.95342 17.0673 6.48711 15.8117ZM12.0007 4C9.21817 4 6.90875 5.19415 5.18623 6.66922C3.47286 8.13646 2.27932 9.93096 1.70892 11.2799C1.51369 11.7416 1.51369 12.2584 1.70892 12.7201C2.27932 14.069 3.47286 15.8635 5.18623 17.3308C6.90875 18.8059 9.21817 20 12.0007 20C14.7646 20 17.024 18.8216 18.7203 17.3613C20.4089 15.9075 21.5859 14.1377 22.2228 12.8245C22.4759 12.3027 22.4759 11.6973 22.2228 11.1755C21.5859 9.86229 20.4089 8.09251 18.7203 6.63872C17.024 5.17836 14.7646 4 12.0007 4ZM14.0007 12C14.0007 13.1046 13.1053 14 12.0007 14C10.8962 14 10.0007 13.1046 10.0007 12C10.0007 10.8954 10.8962 10 12.0007 10C13.1053 10 14.0007 10.8954 14.0007 12ZM16.0007 12C16.0007 14.2091 14.2099 16 12.0007 16C9.79159 16 8.00073 14.2091 8.00073 12C8.00073 9.79086 9.79159 8 12.0007 8C14.2099 8 16.0007 9.79086 16.0007 12Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.187b44b5c4ebcefa030ef7c23da8fd49.svg";
export { ForwardRef as ReactComponent };